import { api } from '../index';

const BASE_PATH = '/api/internal/planning/unplanned_patients';

export type UnplannedPatient = {
  patientId: number;
  patientFullName: string;
  unplannedCareers: string[];
};

export const unplannedPatientsApi = {
  index(groupIds?: number[]): Promise<UnplannedPatient[]> {
    const params: Record<string, unknown> = {};
    if (groupIds && groupIds.length > 0) params['group_id_in[]'] = groupIds;

    return api({
      method: 'get',
      url: BASE_PATH,
      params,
    }).then((response) => response.data.unplannedPatients);
  },
};
